var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14314_13549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2357 0.777344H3.29266C2.69969 0.777344 2.13102 1.01386 1.71173 1.43486C1.29244 1.85586 1.05688 2.42686 1.05688 3.02224V20.9814C1.05688 21.5768 1.29244 22.1478 1.71173 22.5688C2.13102 22.9898 2.69969 23.2263 3.29266 23.2263H16.7073C17.3003 23.2263 17.8689 22.9898 18.2882 22.5688C18.7075 22.1478 18.9431 21.5768 18.9431 20.9814V7.51204L12.2357 0.777344Z",
    stroke: "#33894E",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2358 0.777344V7.51204H18.9432",
    stroke: "#33894E",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4715 13.1211H5.52844",
    stroke: "#ADD0B8",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4715 17.6133H5.52844",
    stroke: "#ADD0B8",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76421 8.63281H6.64633H5.52844",
    stroke: "#ADD0B8",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14314_13549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.314f8de4fa292c5f8d5f89e21d61aa9b.svg";
export { ForwardRef as ReactComponent };